export default[
    {
        path: '/dataList/packCardTrade',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '套餐卡交易数据',
            authLogin: true
        }
    },
]